import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  Xdp,
  XdpServerResponse,
  API_PATH_XDPS,
} from './xdp.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getXdps(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<Xdp | XdpServerResponse>> {
  return http.get(`${API_PATH_XDPS}/${deliveryFunctionId}`);
}

export function getXdp(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<Xdp | XdpServerResponse>> {
  return http.get(`${API_PATH_XDPS}/${deliveryFunctionId}/${id}`);
}

export function deleteXdp(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<Xdp | XdpServerResponse>> {
  return http.delete(`${API_PATH_XDPS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}

export function createXdp(
  deliveryFunctionId: string,
  body: WithAuditDetails<Xdp | XdpServerResponse>,
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_XDPS}/${deliveryFunctionId}`, body);
}

export function updateXdp(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<Xdp | XdpServerResponse>,
): AxiosPromise<ServerResponse<void>> {
  return http.put(`${API_PATH_XDPS}/${deliveryFunctionId}/${id}`, body);
}
